<template>
  <client-only>
    <div>
      <v-tabs v-model="tabValue" :align-tabs="props.alignTabs" :height="48" color="orange50" :class="tabsClass">
        <v-tab v-for="tab in props.tabs" :key="tab.value" :value="tab.value" :class="tabClass">
          {{ tab.label }}
        </v-tab>
      </v-tabs>

      <v-window v-model="tabValue">
        <v-window-item v-for="tab in props.tabs" :key="tab.value" :value="tab.value">
          <component :is="tab.contentComponent" v-bind="tab.contentComponentProps" />
        </v-window-item>
      </v-window>
    </div>
  </client-only>
</template>

<script lang="ts" setup>
import { type Component } from 'vue'

export interface Tab {
  label: string
  value: string
  contentComponent: Component
  contentComponentProps?: Record<string, unknown>
}

interface Props {
  tabs: Tab[]
  alignTabs?: 'center' | 'end' | 'start' | 'title'
  tabsClass?: ClassType
  tabClass?: ClassType
}

defineOptions({ name: 'BaseTabs' })

const props = withDefaults(defineProps<Props>(), {
  alignTabs: 'start',
})

const modelValue = defineModel<string>({ required: false })

const tabValue = computed({
  get() {
    return typeof modelValue.value === 'undefined' ? props.tabs[0]?.value : modelValue.value
  },
  set(value) {
    modelValue.value = value
  },
})
</script>
